export default __webpack_public_path__ + "static/media/back.f34e2944.svg";